import { Routes } from '@angular/router';
import { AuthLayout } from './layouts/auth/auth-layout/auth-layout';
import { MainLayout } from './layouts/main/main-layout/main-layout';
import { authGuard } from '@core/guards/auth';
import { rootRedirectGuard } from '@core/guards/root-redirect';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canMatch: [rootRedirectGuard],
    loadComponent: () => import('@features/blank/blank').then((m) => m.Blank),
  },
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        loadComponent: () => import('@features/auth/pages/login/login').then((c) => c.Login),
      },
      {
        path: '2fa',
        canActivate: [authGuard],
        loadComponent: () => import('@auth/pages/two-factor/two-factor').then((c) => c.TwoFactor),
      },
      {
        path: 'register',
        loadComponent: () => import('@features/register/register').then((c) => c.Register),
      },
    ],
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('@features/account-home/account-home').then((c) => c.AccountHome),
      },
      {
        path: 'personal-info',
        loadComponent: () =>
          import('@features/personal-info/personal-info').then((c) => c.PersonalInfo),
      },
      {
        path: 'security',
        loadComponent: () => import('@features/security/security').then((c) => c.Security),
      },
      {
        path: 'addresses',
        loadComponent: () => import('@features/addresses/addresses').then((c) => c.Addresses),
      },
      {
        path: 'education',
        loadComponent: () =>
          import('@features/user-education/user-education').then((c) => c.UserEducation),
      },
      {
        path: 'jobs',
        loadComponent: () => import('@features/jobs/jobs').then((c) => c.Jobs),
      },
    ],
  },
  {
    path: 'verify-account',
    loadComponent: () =>
      import('@layouts/security/verify-account/verify-account').then((c) => c.VerifyAccount),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@layouts/security/forgot-password/forgot-password').then((c) => c.ForgotPassword),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('@layouts/security/reset-password/reset-password').then((c) => c.ResetPassword),
  },
];
